/**
 * @description Fichier de configuration pour afficher l'information
 * @author Samuel Dubé
 * @example
 *  {String} lang: Contient la clé pour le fichier de traduction
 *  {String} group: Identifie un groupe d'appartenance pour l'information par sa clé langue
 *  {Function} transform: Callback function pour transformer la valeur
 *  {String} tooltip: Information à afficher dans le tooltip
 */
export default {
  nom_application: {
    lang: "tableKeys.nom_application"
  },
  cle_logiciel_unique: {
    lang: "tableKeys.cle_logiciel_unique"
  },
  affichage: {
    lang: "tableKeys.affichage"
  },
  notification_texto: {
    lang: "tableKeys.notification_texto",
    group: "sections.detailsSoftwareSection.notifications"
  },
  notification_email: {
    lang: "tableKeys.notification_email",
    group: "sections.detailsSoftwareSection.notifications"
  },
  seuil_keepalive_critique: {
    lang: "tableKeys.seuil_keepalive_critique",
    group: "sections.detailsSoftwareSection.seuils"
  },
  seuil_keepalive_avertissement: {
    lang: "tableKeys.seuil_keepalive_avertissement",
    group: "sections.detailsSoftwareSection.seuils"
  },
  etat: {
    lang: "tableKeys.etat",
    transform: v =>
      v === 2
        ? "Arrêté"
        : v === 1
        ? "Avertissement"
        : v === 0
        ? "En marche"
        : "Aucunes données"
  },
  ip: {
    lang: "tableKeys.ip"
  },
  nom: {
    lang: "tableKeys.nom"
  },
  moyenne_CPU: {
    lang: "tableKeys.moyenne_CPU",
    tooltip: "tableKeys.moyenne_CPU_tooltip",
    transform: v => v + "%"
  },
  disque: {
    lang: "tableKeys.disque"
  },
  client_pays: {
    lang: "tableKeys.pays"
  },
  client_province: {
    lang: "tableKeys.province"
  },
  client_ville: {
    lang: "tableKeys.ville"
  },
  client_nom: {
    lang: "tableKeys.nom_client"
  },
  client_muet: {
    lang: "tableKeys.muet",
    transform: v => (v == 0 ? "Non" : "Oui")
  }
};
